/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { Select, Size, Heading } from '@vaisala-rockhopper/components';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import './ConfiguratorUtilSelectComponent.scss';

export interface ConfiguratorUtilSelectComponentProps {
  variant?: 'light' | 'dark';
  options?: string[]
  heading?: string
  disabled?: boolean
  onConfiguratorSelectChange?(value: string, position: string): void;
  width?: Size
  onTransmitterOptionChange?(select_key: string, selected: string): void
  label?: string
  select_key?: string
  selected?: string
  onHoveredCableChange?(value: string): void
}

const ConfiguratorUtilSelectComponent = ({ ...props }: ConfiguratorUtilSelectComponentProps) => {

    const [select, setSelect] = React.useState({value: "", titleText: ""});
    const options = props.options ?? [];

    const handleChange = (selectedValue: any) => {
        if (props.onTransmitterOptionChange) {
            props.onTransmitterOptionChange(props.select_key ?? "", selectedValue)
        } else if (props.onConfiguratorSelectChange) {
            props.onConfiguratorSelectChange(selectedValue, props.select_key ?? "")
        }
        setSelect((prevState) => {
            return ({
                ...prevState,
                value: selectedValue
            })
        })
    }

    React.useEffect(() => {
        if (options.length > 0) {
            if (props.selected !== "" && props.selected !== undefined) {
                if (options.includes(props.selected)) {
                    setSelect(prevState => ({...prevState, value: props.selected !== "" && props.selected !== undefined  ? props.selected : options[0]}))
                } else {
                    setSelect(prevState => ({...prevState, value: options[0]}))
                }
            } else {
                setSelect(prevState => ({...prevState, value: options[0]}))
            }
            setSelect(prevState => ({...prevState, value: props.selected !== "" && props.selected !== undefined  ? props.selected : options[0]}))
            if (props.onTransmitterOptionChange) {
                if (props.selected === undefined || props.selected === "") {
                    props.onTransmitterOptionChange(props.select_key ?? "", options[0])
                } else if (!options.includes(props.selected)) {
                    props.onTransmitterOptionChange(props.select_key ?? "", options[0])
                }
            } else if (props.onConfiguratorSelectChange) {
                if (props.selected === undefined || props.selected === "") {
                    props.onConfiguratorSelectChange(options[0], props.select_key ?? "")
                } else if (!options.includes(props.selected)) {
                    props.onConfiguratorSelectChange(options[0], props.select_key ?? "")
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.options]);

    return (
        <div className="configurator-util-select-component-wrapper">
            {props.heading &&
                <Heading level={3}>{props.heading}</Heading>
            }
            <Select
                onChange={handleChange}
                width={props.width}
                selectDivTitle={select.titleText}
                value={select.value}
                className={`select-component select-component-${props.variant ?? 'light'}`}
                onMouseEnter={() => props.onHoveredCableChange ? props.onHoveredCableChange(props.select_key ?? '') : undefined}
                onMouseLeave={() => props.onHoveredCableChange ? props.onHoveredCableChange('') : undefined}
            >
                {options?.map((val, i) => {
                    return <Select.Option key={`${props.heading}-${val}`} title={val} value={val}>{(props.label ?? "") + ': ' + val + (val !== "No cable" ? ' m' : '')}</Select.Option>
                 })}
            </Select>
        </div>
    );
};

export default ConfiguratorUtilSelectComponent;
